<div>
  <router-outlet></router-outlet>
</div>
<div class="text-center mt-3">
  <a role="button" href="#/account/login">{{strings.Cancel}}</a>
</div>